import classes from "./login-content.module.scss";

import { useCallback } from "react";

import { useAuthContext } from "@honeycomb/mystique";
import { Button } from "@honeycomb/ui";
import { LogIn, Mail, ShieldCheck } from "lucide-react";

export const LoginContentForm = () => {
  const { login, availableProviders } = useAuthContext();

  const handleAuth0Login = useCallback(
    (connectionType?: "email") => {
      return () => {
        login({ connection: connectionType });
      };
    },
    [login]
  );

  const handleIdentityLogin = useCallback(() => {
    login({ provider: "hivemind" });
  }, [login]);

  const hasAuth0 = availableProviders.includes("auth0");
  const hasIdentity = availableProviders.includes("hivemind");

  return (
    <form className={classes["login-form"]}>
      <div className={classes["login-actions"]}>
        {hasAuth0 && (
          <>
            <Button type="primary" data-cy="log-in-email" onClick={handleAuth0Login("email")}>
              <Mail /> Send Email Passcode
            </Button>
            <Button type="text" data-cy="log-in-password" onClick={handleAuth0Login()}>
              <LogIn /> Password Sign In
            </Button>
          </>
        )}
        {hasIdentity && (
          <Button type="text" data-cy="log-in-sso" onClick={handleIdentityLogin}>
            <ShieldCheck /> Vision Group Retail SSO
          </Button>
        )}
      </div>
    </form>
  );
};
